import { useState } from "react";

export function useFormControl(stateInisial) {
  const [dataUser, setDataUser] = useState(stateInisial);
  const [errorForm, saveError] = useState("");
  const [spinner, setSpinner] = useState(false);
  const [sended, setSendedEmail] = useState("");

  const handleChange = (e) => {
    setDataUser({
      ...dataUser,
      [e.target.name]: e.target.value,
    });
  };
  const { user_name, user_email, user_subject, message } = dataUser;

  function showTemporaryMessage(setter, messageText, duration = 4000) {
    setter(messageText);
    window.setTimeout(() => setter(""), duration);
  }

  async function handleSubmit(e) {
    e.preventDefault();

    if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(user_email)) {
      showTemporaryMessage(saveError, "You must enter a valid email!");
    } else if (
      user_name.trim() === "" ||
      user_email.trim() === "" ||
      user_subject.trim() === "" ||
      message.trim() === ""
    ) {
      showTemporaryMessage(saveError, "All fields are required!");
    } else {
      setSpinner(true);
      saveError("");

      try {
        const response = await fetch("/api/contact.php", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(dataUser),
        });

        const result = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(result.message || "The email service is unavailable.");
        }

        setDataUser(stateInisial);
        showTemporaryMessage(
          setSendedEmail,
          result.message || "Message sent successfully.",
          4000
        );
      } catch (error) {
        showTemporaryMessage(
          saveError,
          error.message || "The message could not be sent. Please try again later."
        );
      } finally {
        setSpinner(false);
      }
    }
  }

  return {
    handleChange,
    handleSubmit,
    errorForm,
    dataUser,
    spinner,
    sended,
  };
}
